import React from "react";

export default function GetStatus({ status }) {
  return (
    <>
      {status ? (
        <span>
          Status:&nbsp;
          {status == 0
            ? "Requested"
            : status == 1
            ? "Not started"
            : status == 2
            ? "Started"
            : status == 3
            ? "Submitted"
            : status == 4
            ? "Submitted"
            : status == 5
            ? "Completed"
            : status == 6
            ? "Rejected"
            : "No Active Milestone"}
        </span>
      ) : (
        ""
      )}
    </>
  );
}
